import { sendEvent } from './event-tracking';

function sendBreedQuizEvents(eventAction: string): void {
  const data = {
    eventCategory: 'Product Guess the Breed Quiz',
    eventAction,
    eventLabel: null,
    eventValue: null,
    handle: window.embark.petHandle,
    petNum: null,
  };
  sendEvent(data);
}

export function init(): void {
  if (!isBreedGameAvailable()) {
    return;
  }
  if (!window.embark.petHandle) {
    throw new Error('Missing required window.embark.petHandle in breed-quiz');
  }

  const questions = document.getElementsByClassName('question-wrapper');
  const answers = document.getElementsByClassName('answer-wrapper');

  const skipButtons = document.getElementsByClassName('breed-quiz-skip-button');
  const carousel = document.getElementById('carousel');
  const breedVideo = document.getElementById('breed-game-video-container');
  const endCard = document.getElementById('the-end');

  if (!questions || !answers || !skipButtons || !carousel || !endCard) {
    throw new Error("breed-quiz: Expected elements don't exist.");
  }

  Array.from(skipButtons).forEach((skipButton) => {
    skipButton.addEventListener('click', function (e) {
      e.preventDefault();
      sendBreedQuizEvents('Skipped');
      Array.from(questions).forEach((questionToHide) => {
        questionToHide.classList.add('hide');
      });
      Array.from(answers).forEach((answerToHide) => {
        answerToHide.classList.add('hide');
      });
      endCard.classList.remove('hide');
      showCorrectMediaForEndScreen(breedVideo, carousel);
    });
  });

  Array.from(questions).forEach((question) => {
    const questionButtons = question.getElementsByClassName('breed-quiz-question-answer-button');
    if (!questionButtons) {
      throw new Error("Question buttons don't exist.");
    }
    Array.from(questionButtons).forEach((questionButton) => {
      questionButton.addEventListener('click', function (e) {
        e.preventDefault();
        const questionNumber = parseInt(question.id.split('-')[1], 10);
        sendBreedQuizEvents(`Answer ${questionNumber + 1}`);
        const answer = document.getElementById(`answer-${questionNumber}`);
        if (!answer) {
          throw new Error(`breed-quiz: Expected answer ${questionNumber} does not exist.`);
        }
        question.classList.add('hide');
        answer.classList.remove('hide');
        carousel.classList.add('hide');
      });
    });
  });

  Array.from(answers).forEach((answer) => {
    const answerButtons = answer.getElementsByClassName('breed-quiz-next-button');
    if (!answerButtons) {
      throw new Error("breed-quiz: Question buttons don't exist.");
    }
    Array.from(answerButtons).forEach((answerButton) => {
      const answerNumber = parseInt(answer.id.split('-')[1], 10);
      if (answerNumber === answers.length - 1) {
        answerButton.addEventListener('click', function (e) {
          e.preventDefault();
          sendBreedQuizEvents('Finished');
          answer.classList.add('hide');
          endCard.classList.remove('hide');
          showCorrectMediaForEndScreen(breedVideo, carousel);
        });
      } else {
        answerButton.addEventListener('click', function (e) {
          e.preventDefault();
          const question = document.getElementById(`question-${answerNumber + 1}`);
          if (!question) {
            throw new Error(`breed-quiz: Expected question ${answerNumber} does not exist.`);
          }
          answer.classList.add('hide');
          question.classList.remove('hide');
          carousel.classList.remove('hide');
        });
      }
    });
  });
}

function isBreedGameAvailable(): boolean {
  return !document.getElementById('breed-game-not-available-reason');
}

function showCorrectMediaForEndScreen(breedVideo: HTMLElement | null, carousel: HTMLElement): void {
  if (breedVideo) {
    breedVideo.classList.remove('hide');
    carousel.classList.add('hide');
  } else {
    carousel.classList.remove('hide');
  }
}
